import moment from "moment-timezone";

const handleValidDateTime = (date) => {
  const localTime = moment.utc(date).local();
  return localTime.format("MMM D, YYYY, HH:mm");
};

export default handleValidDateTime;